// extracted by mini-css-extract-plugin
export default {"primaryList":"termAndConditions_primaryList__aTdC7","secondaryList":"termAndConditions_secondaryList__grTz2"};